import { registerPlugin } from '@capacitor/core'

interface RemotePollingPlugin {
  start(options: {
    apiUrl: string
    token: string
    deviceId: string
    appVersion?: string
  }): Promise<{ running: boolean }>
  stop(): Promise<{ running: boolean }>
  status(): Promise<{ running: boolean }>
}

const RemotePolling = registerPlugin<RemotePollingPlugin>('RemotePolling')

export function startRemotePolling(options: {
  apiUrl: string
  token: string
  deviceId: string
  appVersion?: string
}): Promise<{ running: boolean }> {
  return RemotePolling.start(options)
}

export function stopRemotePolling(): Promise<{ running: boolean }> {
  return RemotePolling.stop()
}
